import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, forkJoin, map} from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';

// sycfusion dialog 
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { JobSubject } from './../../../shared/models/jobSubject.model';
import { NgForm } from '@angular/forms';

import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { DataUtil } from '@syncfusion/ej2-data';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';

@Component({
  selector: 'app-job-details-edit-widget',
  templateUrl: './job-details-edit-widget.component.html',
  styleUrls: ['./job-details-edit-widget.component.css']
})
export class JobDetailsEditWidgetComponent implements  OnChanges {



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
   @Input() subjectValidationIssues: any[] = [];
   @Input() subjectValidationPending = false;
   @Output() subjectSetupUpdated = new EventEmitter<any>();

//// SyncFusion Dialog
@ViewChild('ejDialog') ejDialog: DialogComponent;
// Create element reference for dialog target element.
@ViewChild('container', { read: ElementRef }) container: ElementRef;
// The Dialog shows within the target element.


     // access the template form
     @ViewChild('jobForm') jobForm: NgForm;

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  sessionUsername: any;
  brands: any;
  brand_users: any;
  sent_brand_id: any;
  brand_report_selected: any;
  selected_brand_data: any;
  new_special_instuctions: any;
  special_instructions: any;
  job_id: any;
  DialogObj: any;
  client_job_submission: any;
  job_type: any;
  job_service_rules: any;
  job_service_timeframes: any;
  sent_job_service_rule_id: any;
  job_type_document_type: any;
  selected_job_service_rule_description: any;
  selected_job_service_timeframe_description: any;
  job_service_rule: any;
  job_service_timeframe: any;
  modalRef: any;
  job_plaintiffs: any;
  all_router_details: string;
  job_status: any;
  hide_content_from_client: number;
  showPrevVersion_Field: any;



  public subject_fields: Object = { text: 'subject_number', value: 'subject_id' };

  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 
  current_subject_count: any;
  subjects2: Object;
  all_current_subjects_results: any;
  new_data: any;
  timeframe_surcharges: any;
  jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};
  private readonly legalJobDateFields = ['judgement_date', 'filing_date', 'hearing_date', 'instructions_date'];
  subjectSetupReadyForOpen = false;
  subjectSetupSyncInProgress = false;
  subjectSetupSyncMessage = 'Opening is locked until the subject cards have been updated with the latest job setup.';
  private subjectSetupSyncedSignature = '';
  private readonly subjectSetupOpenGuardStoragePrefix = 'txc-step3-subject-setup-ready:';


  constructor(   private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private sanitizer: DomSanitizer,
     private clipboard: Clipboard, // ciipboard
     public legalDate: LegalDateTimeService,
     ) {

      this.nav = document.querySelector('nav.navbar');
    //  this.toastr.setRootViewContainerRef(vcr);

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      }



         // check for changes. to load data.
   ngOnChanges(changes) {
    this.hide_content_from_client = 0;
    if (changes.item_id) {
      this.resetSubjectSetupOpenGuard();
      // deal with asynchronous Observable result
      this.job_id = changes.item_id.currentValue;
      this.getJob(this.job_id);
      this.getJobServiceRules();
      this.getJobServiceTimeframes();
     this.getJobStatusNames();
      // have to reset the route as it was not hiding the fields I required.
      this.gfunc.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
    }

    if (this.router.url.includes('/client/jobs/create-job-wizard-step-2')) {
      this.hide_content_from_client = 1;
      console.log('We are on client page step two - create job')
    } else {
      //  return '';
    }


  }





  getJob(job_id) {


    this.getJobTypes();
    this.getPositions();
    this.getClients();
    this.getJobSubjectTypes();
    this.getJobPlaintiffTypes();
    this.getBrands();
    this.getJobPlaintiffs(job_id);

        this.getTimeframeSurcharges();


    // To load the subject 1 details from a submitted job, to update subject 1 with job details.
    this.getJobSubjects(job_id)

    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
        this.initializeJobDatePickerValues(this.job);
      this.restoreSubjectSetupOpenGuardIfCurrent();
      // Need to load the drop downs (only if a process is selected.)
      this.getJobTypeLocations(res.job_type_id);
      this.getJobTypeCourts(res.job_type_location_id);
      this.getJobTypeDocumentTypes(res.job_type_court_id);
      this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      // need to load client contact
      this.getClientContactsSharmans(res.client_id);
      
      this.getBrandUsers(res.brand_report_id);


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  



// syncfusion dialog simple sample
public onOpenDialog = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Job Submissions <span class="text-warning font-bold"> ::[ Send to Sharmans ]:: ',
    // tslint:disable-next-line:max-line-length
    content: '<b>Package my job and send to Sharmans. It\'s ready to go!</b> <br><br> <p class="text-success font-bold">We will notify you when its approved ready for service.</p> ',
    okButton: {  text: 'Yes, Please!', click: this.okClick.bind(this, model) },
    cancelButton: {  text: 'No Thanks.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}


public onOpenDialogAdmin = function(event: any, model): void {
  if (this.isAdminStaffStep3Route() && !this.canOpenJobToAction()) {
    this.toastr.error(this.getOpenJobBlockedMessage());
    return;
  }

  this.DialogObj = DialogUtility.confirm({
    title: 'Job Submissions <span class="text-danger font-bold"> ::[ OPEN JOB & SUBJECTS ]:: ',
    // tslint:disable-next-line:max-line-length
    content: '<b>OPEN job ready for processing in the portal!</b> <br><br> <p class="text-success font-bold">We will notify the Report Client its ready and in service.</p> ',
    okButton: {  text: 'OK', click: this.okClickAdmin.bind(this, model) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}

public okClick(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
 this.clientJobSubmission(this.job_id, model);
 this.DialogObj.hide();
}

public okClickAdmin(model): void {
  //  alert('you clicked Yes, Please! are you really really sure??? Really');
  // this.createJobSubjectsMultiple(this.newSubject);
  if (this.isAdminStaffStep3Route() && !this.canOpenJobToAction()) {
    this.toastr.error(this.getOpenJobBlockedMessage());
    this.DialogObj.hide();
    return;
  }

  this.adminJobSubmission(this.job_id, model);
  this.DialogObj.hide();
 }

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}





// :: Send Job: Client Submission update all subjects and job to pending
clientJobSubmission(job_id, model){
  this._demoService.clientJobSubmission(job_id)
  .subscribe(
    res => {
      this.client_job_submission = res;
     // let data = res[0];


// console.log('Submission Model: ' + JSON.stringify(model));

     this.gfunc.insertLog_UpdateJobSubmission(model);


     this.toastr.success('Job Submitted.');
    //  this.gfunc.globalJobView(job_id);


    },
    err => console.error(err.status)
  );
}

adminJobSubmission(job_id, model){
  this._demoService.adminJobSubmission(job_id)
  .subscribe(
    res => {
      this.client_job_submission = res;

     // let data = res[0];
     this.toastr.success('Job Submitted.');
     // new log event to notify the client and enable another tirgger in the system
     this.gfunc.insertLog_OpenJobReadyForAction(model);
    this.gfunc.globalJobView(job_id);
    },
    err => console.error(err.status)
  );
}


// get job type details.
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { 
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

  
  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
  
  
  
   console.log('sending Count:' + this.count2);
  }
  
  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  
  
   console.log('sending Location:' + this.sent_job_type_location_id);
  }
  
  
  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; 

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }
  


  sendJobServiceRuleID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    // this.sent_job_service_rule_id = job_service_rule_id;

    this.sent_job_type_document_type_id = job_type_document_type_id;
  //  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  


          //   IMPLIMENTATION of Service Timeframes & Service Rules associated with document selection
          // ::@ Try to set the service rule and service timeframes from document here.
          //    What is the current selected DocumentID - lookup the  timeframes, and service rule IDS
          //    Then set them into the model and save as new variables as part of the job.
          //     TODO:: need to impliment this on create a job and set for all subjects on a subject level with defaults.
          //  this.model.job_service_rule_id = 
  



// Now lookup the Serice rule and set the selection with the ids.
    this.getJobTypeDocumentType(this.sent_job_type_document_type_id);
// NOW need to repeat this action for the service timeframes.


   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }



  getJobTypeDocumentType(job_type_document_type_id) {
    this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
       data => { this.job_type_document_type = data;
      let res = data[0];
      // Set the new form variables After the selected drop down of documents activated this function;
      // note :: SUCCESS (This also updates the model object variables in the form)
      this.jobForm.controls['job_service_rule_id'].setValue( res.job_service_rule_id);
      this.jobForm.controls['job_service_timeframe_id'].setValue( res.job_service_timeframe_id);
   
// Display the Rule Definition in UI/Template
// Need to do a quick lookup to get the values to set below both Timeframes and Rule Definitions on the page

this.getJobServiceRule(res.job_service_rule_id);
this.getJobServiceTimeframe(res.job_service_timeframe_id);





      // this.model.job_service_rule_id = res.job_service_rule_id;
      //   console.log('New job_service_rule_id ' + this.model.job_service_rule_id);
    },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  
  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  
   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }
  
  
  


  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
        this.selected_job_service_rule_description = res.job_service_rule_description;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
        this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }






  getClients() {
    this._demoService.getClients().subscribe(
       data => { this.clients = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { this.client_contacts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendClientID(client_id) {
   this.sent_client_id = client_id;
   this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....
  
   console.log('sending Client ID:' + this.sent_client_id);
  }
  
  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }
  
  
  
  // update was here for onit but moved for onchange
  saveJobSetupAndUpdateSubjectCards(model) {
    if (!this.isAdminStaffStep3Route()) {
      this.updateJobAll(model);
      return;
    }

    if (this.subjectSetupSyncInProgress) {
      return;
    }

    this.subjectSetupReadyForOpen = false;
    this.subjectSetupSyncInProgress = true;
    this.subjectSetupSyncMessage = 'Saving job setup and updating subject cards...';
    model.updated_by = this.sessionUserId;

    if (model.special_instructions_HTML == null) {
      model.special_instructions_HTML = model.special_instructions;
    }

    this._demoService.updateJobAll(model).subscribe(
      data => {
        this._demoService.getJobSubjects(model.job_id).subscribe(
          subjects => {
            this.subjects2 = subjects;
            const currentSubjects: any[] = Array.isArray(subjects) ? subjects : [];
            const subjectsToUpdate = currentSubjects.filter(subject => !this.isClosedSubjectForSetupSync(subject));

            if (subjectsToUpdate.length < 1) {
              this.subjectSetupSyncInProgress = false;
              this.subjectSetupReadyForOpen = false;
              this.subjectSetupSyncMessage = 'No open subject cards were found to update. The job was not opened.';
              this.toastr.error('The job was not opened. Please save/update subject cards again before opening.');
              return;
            }

            const fullSubjectRequests = subjectsToUpdate.map(subject => this._demoService.getJobSubject(subject.subject_id));

            forkJoin(fullSubjectRequests).subscribe(
              subjectDetailsResults => {
                const updateRequests = subjectDetailsResults.map((subjectDetailsResult: any, index: number) => {
                  const fullSubject = Array.isArray(subjectDetailsResult) && subjectDetailsResult.length > 0
                    ? subjectDetailsResult[0]
                    : subjectsToUpdate[index];
                  const syncModel = this.buildSubjectSetupSyncModel(fullSubject, model);
                  return this._demoService.updateJobSubject(syncModel);
                });

                forkJoin(updateRequests).subscribe(
                  () => {
                    this.subjectSetupSyncedSignature = this.getSubjectSetupSignature(model);
                    this.subjectSetupSyncInProgress = false;
                    this.subjectSetupReadyForOpen = true;
                    this.subjectSetupSyncMessage = 'Subject cards updated. You can now open this job for action.';
                    this.persistSubjectSetupOpenGuard(model, subjectsToUpdate);
                    this.toastr.success('Subject cards updated. You can now open this job for action.');
                    this.gfunc.insertLog_UpdateJob(model);
                    this.getJobSubjects(model.job_id);
                    this.subjectSetupUpdated.emit({ job_id: model.job_id });
                  },
                  error => {
                    this.handleSubjectSetupSyncFailure(error, model.job_id);
                  }
                );
              },
              error => {
                this.handleSubjectSetupSyncFailure(error, model.job_id);
              }
            );
          },
          error => {
            this.handleSubjectSetupSyncFailure(error, model.job_id);
          }
        );
      },
      error => {
        this.handleSubjectSetupSyncFailure(error, model.job_id);
      }
    );
  }

  private isClosedSubjectForSetupSync(subject): boolean {
    const status = (subject?.job_status_code || subject?.job_status || '').toString().toUpperCase();
    return status === 'CLOSED';
  }

  private buildSubjectSetupSyncModel(subject, jobModel) {
    return {
      ...subject,
      updated_by: this.sessionUserId,
      job_reference_number: jobModel.job_reference_number,
      owner_trace_code: jobModel.owner_trace_code,
      job_type_id: jobModel.job_type_id,
      job_type_location_id: jobModel.job_type_location_id,
      job_type_court_id: jobModel.job_type_court_id,
      job_type_document_type_id: jobModel.job_type_document_type_id,
      job_type_affidavit_type_id: jobModel.job_type_affidavit_type_id,
      job_status: jobModel.job_status_code,
      brand_report_user_id: jobModel.brand_report_user_id,
      brand_report_id: jobModel.brand_report_id,
      brand_invoice_id: jobModel.brand_invoice_id,
      job_service_rule_id: jobModel.job_service_rule_id,
      job_service_timeframe_id: jobModel.job_service_timeframe_id,
      service_company_name: jobModel.service_company_name,
      service_directors_name: jobModel.service_directors_name,
      service_prison_name: jobModel.service_prison_name,
      service_law_firm_name: jobModel.service_law_firm_name,
      service_solicitor_name: jobModel.service_solicitor_name,
      special_instructions_HTML: jobModel.special_instructions_HTML,
      timeframe_surcharge_id: jobModel.timeframe_surcharge_id,
      instructions_date: jobModel.instructions_date,
      hearing_date: jobModel.hearing_date,
      judgement_date: jobModel.judgement_date,
      filing_date: jobModel.filing_date
    };
  }

  private handleSubjectSetupSyncFailure(error, jobId?: any): void {
    this.clearPersistedSubjectSetupOpenGuard(jobId);
    this.subjectSetupSyncInProgress = false;
    this.subjectSetupReadyForOpen = false;
    this.subjectSetupSyncMessage = 'The job was not opened. Please save/update subject cards again before opening.';
    this.toastr.error('The job was not opened. Please save/update subject cards again before opening.');
    return console.log(error);
  }

  updateJobAll(model) {
    model.updated_by = this.sessionUserId;
    this._demoService.updateJobAll(model).subscribe(
       data => { 
       this.toastr.success('Job Updated');
       // Now upgraded to automatically upgrade subject 1
       this.updateSubject1FromJobDetails(model) // 23.11.24 --- BUG... THIS IS CAUSING ISSUES !!!!!!! -- I ethier need to seperate this function or not run it at all ---- 

       // test 
       // ## this needs to be a new function to update all subjects. -- function get all subjects  and lop undate subject 1 function as a new cunction
      //  createJobSubjectsMultiple(model) // I need to loop and update each subject with job_id --- and update report_brand_id
            // if(model.update_all_subjects){
            //   alert('updating all subjects'); }

            // Do this automatically
              this.updateAllSubjectsFromJobDetails(model);
           

       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
      this.gfunc.insertLog_UpdateJob(model);
      this.gfunc.globalJobView(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       }
  );
  }

  isAdminStaffStep3Route(): boolean {
    return this.gfunc.current_base_route == '/admin/jobs/create-job-3'
      || this.gfunc.current_base_route == '/staff/jobs/create-job-3';
  }

  canOpenJobToAction(): boolean {
    return this.subjectSetupReadyForOpen
      && !this.subjectSetupSyncInProgress
      && this.getSubjectValidationIssues().length === 0;
  }

  getSubjectValidationIssues(): any[] {
    return Array.isArray(this.subjectValidationIssues) ? this.subjectValidationIssues : [];
  }

  getOpenJobBlockedMessage(): string {
    const validationIssues = this.getSubjectValidationIssues();

    if (!this.subjectSetupReadyForOpen) {
      return 'The job was not opened. Please save/update subject cards again before opening.';
    }

    if (validationIssues.length > 0) {
      const firstIssue = validationIssues[0];
      const subjectLabel = this.getSubjectValidationLabel(firstIssue);
      const missingFields = this.getSubjectMissingFieldsText(firstIssue);
      return 'The job was not opened. Please update ' + subjectLabel + ': missing ' + missingFields + '.';
    }

    return 'The job was not opened. Please save/update subject cards again before opening.';
  }

  getSubjectValidationLabel(issue: any): string {
    if (!issue) {
      return 'the subject card';
    }

    if (issue.subject_number) {
      return 'Subject ' + issue.subject_number;
    }

    if (issue.tab_index !== undefined && issue.tab_index !== null) {
      return 'Subject ' + (Number(issue.tab_index) + 1);
    }

    return 'the subject card';
  }

  getSubjectMissingFieldsText(issue: any): string {
    const invalidFields = Array.isArray(issue?.invalid_fields) ? issue.invalid_fields : [];

    if (invalidFields.length < 1) {
      return 'required information';
    }

    return invalidFields.slice(0, 5).join(', ') + (invalidFields.length > 5 ? ' and more' : '');
  }

  resetSubjectSetupOpenGuard(): void {
    this.subjectSetupReadyForOpen = false;
    this.subjectSetupSyncInProgress = false;
    this.subjectSetupSyncMessage = 'Opening is locked until the subject cards have been updated with the latest job setup.';
    this.subjectSetupSyncedSignature = '';
  }

  markSubjectSetupDirty(model?: any): void {
    if (!this.isAdminStaffStep3Route() || this.subjectSetupSyncInProgress) {
      return;
    }

    if (model && this.subjectSetupSyncedSignature && this.getSubjectSetupSignature(model) === this.subjectSetupSyncedSignature) {
      return;
    }

    this.clearPersistedSubjectSetupOpenGuard(model?.job_id);
    this.subjectSetupReadyForOpen = false;
    if (!this.subjectSetupSyncInProgress) {
      this.subjectSetupSyncMessage = 'Opening is locked until the subject cards have been updated with the latest job setup.';
    }
  }

  private restoreSubjectSetupOpenGuardIfCurrent(): void {
    if (!this.isAdminStaffStep3Route() || this.subjectSetupSyncInProgress) {
      return;
    }

    const jobModel = Array.isArray(this.job) && this.job.length > 0 ? this.job[0] : null;
    const currentSubjects = Array.isArray(this.subjects2) ? this.subjects2 : null;

    if (!jobModel || !currentSubjects) {
      return;
    }

    const persistedState = this.getPersistedSubjectSetupOpenGuard(jobModel.job_id);
    if (!persistedState) {
      return;
    }

    const currentSignature = this.getSubjectSetupSignature(jobModel);
    const currentSubjectIds = this.getOpenSubjectSetupSubjectIds(currentSubjects);

    if (persistedState.signature === currentSignature && this.sameSubjectSetupSubjectIds(persistedState.subjectIds, currentSubjectIds)) {
      this.subjectSetupSyncedSignature = currentSignature;
      this.subjectSetupReadyForOpen = true;
      this.subjectSetupSyncInProgress = false;
      this.subjectSetupSyncMessage = 'Subject cards were already updated. You can open this job for action. If you edited a subject after that, save that subject card directly before opening.';
      return;
    }

    this.clearPersistedSubjectSetupOpenGuard(jobModel.job_id);
  }

  private persistSubjectSetupOpenGuard(model: any, syncedSubjects: any[]): void {
    if (!model?.job_id) {
      return;
    }

    const state = {
      signature: this.getSubjectSetupSignature(model),
      subjectIds: this.getOpenSubjectSetupSubjectIds(syncedSubjects)
    };

    try {
      sessionStorage.setItem(this.getSubjectSetupOpenGuardStorageKey(model.job_id), JSON.stringify(state));
    } catch (error) {
      // Non-critical. The guard still works until the component is recreated.
    }
  }

  private getPersistedSubjectSetupOpenGuard(jobId: any): any {
    if (!jobId) {
      return null;
    }

    try {
      const rawState = sessionStorage.getItem(this.getSubjectSetupOpenGuardStorageKey(jobId));
      return rawState ? JSON.parse(rawState) : null;
    } catch (error) {
      return null;
    }
  }

  private clearPersistedSubjectSetupOpenGuard(jobId: any): void {
    if (!jobId) {
      return;
    }

    try {
      sessionStorage.removeItem(this.getSubjectSetupOpenGuardStorageKey(jobId));
    } catch (error) {
      // Non-critical.
    }
  }

  private getSubjectSetupOpenGuardStorageKey(jobId: any): string {
    return this.subjectSetupOpenGuardStoragePrefix + jobId;
  }

  private getOpenSubjectSetupSubjectIds(subjects: any[]): string[] {
    return (Array.isArray(subjects) ? subjects : [])
      .filter(subject => !this.isClosedSubjectForSetupSync(subject))
      .map(subject => String(subject?.subject_id || ''))
      .filter(subjectId => subjectId !== '')
      .sort();
  }

  private sameSubjectSetupSubjectIds(first: any[], second: any[]): boolean {
    const firstIds = Array.isArray(first) ? first.map(subjectId => String(subjectId)).sort() : [];
    const secondIds = Array.isArray(second) ? second.map(subjectId => String(subjectId)).sort() : [];

    return firstIds.length === secondIds.length
      && firstIds.every((subjectId, index) => subjectId === secondIds[index]);
  }

  private getSubjectSetupSignature(model: any): string {
    return JSON.stringify({
      job_reference_number: model?.job_reference_number ?? null,
      owner_trace_code: model?.owner_trace_code ?? null,
      job_type_id: model?.job_type_id ?? null,
      job_type_location_id: model?.job_type_location_id ?? null,
      job_type_court_id: model?.job_type_court_id ?? null,
      job_type_document_type_id: model?.job_type_document_type_id ?? null,
      job_type_affidavit_type_id: model?.job_type_affidavit_type_id ?? null,
      job_status_code: model?.job_status_code ?? null,
      brand_report_user_id: model?.brand_report_user_id ?? null,
      brand_report_id: model?.brand_report_id ?? null,
      brand_invoice_id: model?.brand_invoice_id ?? null,
      job_service_rule_id: model?.job_service_rule_id ?? null,
      job_service_timeframe_id: model?.job_service_timeframe_id ?? null,
      service_company_name: model?.service_company_name ?? null,
      service_directors_name: model?.service_directors_name ?? null,
      service_prison_name: model?.service_prison_name ?? null,
      service_law_firm_name: model?.service_law_firm_name ?? null,
      service_solicitor_name: model?.service_solicitor_name ?? null,
      special_instructions_HTML: model?.special_instructions_HTML ?? null,
      special_instructions: model?.special_instructions ?? null,
      timeframe_surcharge_id: model?.timeframe_surcharge_id ?? null,
      instructions_date: model?.instructions_date ?? null,
      hearing_date: model?.hearing_date ?? null,
      judgement_date: model?.judgement_date ?? null,
      filing_date: model?.filing_date ?? null
    });
  }

  getJobDateKey(model: any): string {
    return String(model?.job_id ?? '');
  }

  getJobDatePickerValue(model: any, field: string): Date | null {
    const key = this.getJobDateKey(model);
    return this.jobDatePickerValues[key]?.[field] ?? null;
  }

  onJobDateChange(field: string, value: unknown, model: any): void {
    const key = this.getJobDateKey(model);
    const pickerDate = this.legalDate.coercePickerDate(value);

    if (!this.jobDatePickerValues[key]) {
      this.jobDatePickerValues[key] = {};
    }

    this.jobDatePickerValues[key][field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
    this.markSubjectSetupDirty(model);
  }

  private initializeJobDatePickerValues(jobs: any[]): void {
    if (!Array.isArray(jobs)) {
      this.jobDatePickerValues = {};
      return;
    }

    const jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};

    jobs.forEach((jobModel) => {
      const key = this.getJobDateKey(jobModel);

      jobDatePickerValues[key] = {};

      this.legalJobDateFields.forEach((field) => {
        jobDatePickerValues[key][field] = this.legalDate.toPickerDate(jobModel?.[field]);
      });
    });

    this.jobDatePickerValues = jobDatePickerValues;
  }





  updateJobAll_Admin(model) {
    model.updated_by = this.sessionUserId;
    this._demoService.updateJobAll(model).subscribe(
       data => { 
       this.toastr.success('Job Updated');
       // Now upgraded to automatically upgrade subject 1
            //  this.updateSubject1FromJobDetails(model) // 23.11.24 --- BUG... THIS IS CAUSING ISSUES !!!!!!! -- I ethier need to seperate this function or not run it at all ---- 

       // test 
       // ## this needs to be a new function to update all subjects. -- function get all subjects  and lop undate subject 1 function as a new cunction
      //  createJobSubjectsMultiple(model) // I need to loop and update each subject with job_id --- and update report_brand_id
            // if(model.update_all_subjects){
            //   alert('updating all subjects'); }
            // Do this automatically
              // this.updateAllSubjectsFromJobDetails(model); // 23.11.24 ?? DOES THIS NOW NOT UPDATE THE SUBJECT
              
              if(model.subject_to_update_choice == 'Choose'){
              this.updateAllSubjectsFromJobDetails_Admin_Choose(model)
              }

              if(model.subject_to_update_choice == 'Update All'){
                if (confirm('Job updated, Please confirm to update ALL JOB SUBJECTS, report contacts with the current selected Report Contact?')) {
                this.updateAllSubjectsFromJobDetails_Admin_All(model)
                }
              }

              // none -- does nothing. :)


       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
      this.gfunc.insertLog_UpdateJob(model);
      this.gfunc.globalJobView(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       }
  );
  }







  


  updateJobAllAndSubject1(model) {

    // this.getJobSubjects(model.job_id) // reset the subjects that were updated below. -- check to see if this fixes the subject type not saving.


    model.updated_by = this.sessionUserId;
    this._demoService.updateJobAll(model).subscribe(
       data => { 

// We also need to update the subject with the new model
// Create sumple function to pass current model then change whats needed.
// updateSubject1FromJobDetails(subject_1_data){};
    // need to lookup current subject get the datas

this.updateSubject1FromJobDetails(model)
       this.toastr.success('Job Updated');
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
//    this.gfunc.insertLog_UpdateJob(model);
//    this.gfunc.globalJobView(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       }
  );
  }
  
  // New Function to ensure Subject 1 gets new job details that were submitted by the client.// then updated by admin or staff
  updateSubject1FromJobDetails(model){

    // this.getJobSubjects(model.job_id)

    const current_subject_1 = this.subjects2[0];
    // change whats needed in a new model

    const subject_1_model = {
      ...current_subject_1,
      // job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      // number_subjects: 1,
      // existing_subjects_count: this.current_subject_count, // set so that increments in sql correctly
      // existing_subjects_count: this.true_subject_count, // Updated to true count to take subject stages in to consideration 2 May 2023
      // file_number: this.current_subject_count, // adds one in api loop
      // reference_number: model.reference_number,
      created_by: this.gfunc.sessionUserId,
      is_active: '1',
      job_type_id: model.job_type_id,
      job_type_location_id: model.job_type_location_id,
      job_type_court_id: model.job_type_court_id,
      job_type_document_type_id: model.job_type_document_type_id,
      job_type_affidavit_type_id: model.job_type_affidavit_type_id,
      job_status: model.job_status_code,
      subject_service_type_id: 1,

      // What Fields Am I missing for a subject... -- That are important -- add here 28/1/24
      // Might need to add in the multiple version as well.
      brand_report_user_id: model.brand_report_user_id,
      brand_report_id: model.brand_report_id,
     
      job_subject_type_id: current_subject_1.job_subject_type_id,  /// --- this was removing the subject job type selected by the subject -- now shold save correctly. july 31 24
      // job_subject_type_id: 2,  /// --- this was removing the subject job type selected by the subject -- now shold save correctly. july 31 24

      job_service_rule_id: model.job_service_rule_id,
      job_service_timeframe_id: model.job_service_timeframe_id,
      service_company_name: model.service_company_name,
      service_directors_name: model.service_directors_name,
      service_prison_name: model.service_prison_name,
      service_law_firm_name: model.service_law_firm_name,
      service_solicitor_name: model.service_solicitor_name,
      special_instructions_HTML: model.special_instructions_HTML,
      timeframe_surcharge_id: model.timeframe_surcharge_id,
      subject_id: this.subjects2[0].subject_id, // has to be declared so that update can proceed below.


    }
    // save update the subject with the new model
    // toastr.success ---
    this.updateJobSubject(subject_1_model) // update subject 1 with the current model.

 


  };


  updateAllSubjectsFromJobDetails(model){

    // August 24
    // Run this as a loop of all subjects just sending (brand_report_user_id)

      // ### SETUP A LOOP and model then insert..../update

              this.all_current_subjects_results = DataUtil.parse.parseJson(this.subjects2);
              // this.subject_service_metrix_search_full_results = data;
              this.new_data = this.all_current_subjects_results.slice(0, 50);


              // Do while push objects to model...
              let  count_of_items = this.new_data.length;
              var dropdopwn_items = [];
              for(let i=0; i < count_of_items; i++) {
              let itemData = this.new_data[i];
              // // push to array to fill below.
              dropdopwn_items.push({ 
              job_id: itemData.subject_id,
              subject_id: itemData.subject_id,
              brand_report_user_id: model.brand_report_user_id, // from the job model not subject
              });

              this.updateAllSubjectContacts(dropdopwn_items[i]);

              }


  };



  /// Now inly updates the subjects that were chosen 23.11.23
  updateAllSubjectsFromJobDetails_Admin_Choose(model){

    // August 24
    // Run this as a loop of all subjects just sending (brand_report_user_id)

      // ### SETUP A LOOP and model then insert..../update

              // this.all_current_subjects_results = DataUtil.parse.parseJson(this.subjects2); 
              this.all_current_subjects_results =  DataUtil.parse.parseJson(model.subject_choose_group); // 23.11.24 - changed to form fields and optins to select.


              // this.subject_service_metrix_search_full_results = data;
              // this.new_data = this.all_current_subjects_results.slice(0, 50);
              this.new_data = this.all_current_subjects_results;


              // Do while push objects to model...
              let  count_of_items = this.new_data.length;
              var dropdopwn_items = [];
              for(let i=0; i < count_of_items; i++) {
              let itemData = this.new_data[i];
              // // push to array to fill below.
              dropdopwn_items.push({ 
              job_id: model.job_id,
              // subject_id: itemData.subject_id,
              subject_id: itemData,
              brand_report_user_id: model.brand_report_user_id, // from the job model not subject
              });

              this.updateAllSubjectContacts(dropdopwn_items[i]);

              }


  };



  updateAllSubjectsFromJobDetails_Admin_All(model){

    // August 24
    // Run this as a loop of all subjects just sending (brand_report_user_id)

      // ### SETUP A LOOP and model then insert..../update

              this.all_current_subjects_results = DataUtil.parse.parseJson(this.subjects2); 
              // this.all_current_subjects_results = model.subject_choose_group; // 23.11.24 - changed to form fields and optins to select.


              // this.subject_service_metrix_search_full_results = data;
              // this.new_data = this.all_current_subjects_results.slice(0, 50);
              this.new_data = this.all_current_subjects_results;


              // Do while push objects to model...
              let  count_of_items = this.new_data.length;
              var dropdopwn_items = [];
              for(let i=0; i < count_of_items; i++) {
              let itemData = this.new_data[i];
              // // push to array to fill below.
              dropdopwn_items.push({ 
              job_id: model.job_id,
              subject_id: itemData.subject_id,
              brand_report_user_id: model.brand_report_user_id, // from the job model not subject
              brand_report_id: model.brand_report_id, // from the job model not subject
              });

              this.updateAllSubjectContacts(dropdopwn_items[i]);

              }


  };



  updateAllSubjectContacts(model){
     this._demoService.updateAllSubjectContacts(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        // this.toastr.success('Subject Updated');
    // this.toastr.success('Subject Updated with Job Contacts Details.');
        // reload the page.
        // this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
      },
      error => {
        // console.error('Error saving Event!');
        // this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.log(err),
      // () => console.log('done updates')


    );
  }



// added to update subject 1 with new model.
  updateJobSubject(model) {
    // first make a copy of subject and place in to subject_history table. // done on insert in PHP
    // Set bew field Automatically on update. if null.
if (model.special_instructions_HTML == null){
  model.special_instructions_HTML = model.special_instructions;
}

    this._demoService.updateJobSubject(model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
        // this.toastr.success('Subject Updated');
        this.toastr.success('Subject 1 Updated with Job Details.');
        // reload the page.
        // this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
      },
      error => {
        // console.error('Error saving Event!');
        // this.toastr.error('Error saving Job!');
       return console.log(error);
      }
      // err => console.log(err),
      // () => console.log('done updates')


    );
  }


  
  // create subjects
  createJobSubjectsMultiple(model) {
  
     this._demoService.createJobSubjectsMuliple(model).subscribe(
        data => {  this.get_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving...');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
  
         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");
   
        // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);
   
           return true;
   
   
        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
         // this.toastr.error('Adding Subjects Failed :: Please try again!');
         // console.log(error(error));
         //return console.log(error);
        }
   );
  }
  

  getJobSubjects(job_id) {
    this._demoService.getJobSubjects(job_id).subscribe(
       data => { this.subjects2 = data;
        let res = data[0];
       // this.getSubjectNotes(res.subject_id);
        this.current_subject_count = Object(this.subjects2).length; // counts the subjects.
        this.restoreSubjectSetupOpenGuardIfCurrent();
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getBrands() {
    this._demoService.getBrands().subscribe(
       data => { this.brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getBrandUsers(brand_report_user_id) {
    this._demoService.getBrandUsers(brand_report_user_id).subscribe(
       data => { this.brand_users = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendBrandID(brand_report_user_id) {
   this.sent_brand_id = brand_report_user_id;
   this.getBrandUsers(this.sent_brand_id); // updates the selected job ID....
  // need to look up what brands notes are and send to jon notes.
  // lookup brand
  this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
  
   //console.log('sending Brand ID:' + this.sent_brand_id);
  }
  
  getBrandById_instructions(brand_id){
    this._demoService.getBrandById(brand_id)
    .subscribe(
      res => {this.brand_report_selected = res;
        this.selected_brand_data = res[0];
       this.new_special_instuctions = this.selected_brand_data.brand_notes;
       this.special_instructions = this.new_special_instuctions;
       console.log('instructions: ' + this.new_special_instuctions);
     
      },
      err => console.error(err.status)
    );
   }





   getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


   getJobServiceTimeframes() {
    this._demoService.getJobServiceTimeframes().subscribe(
       data => { this.job_service_timeframes = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobViewSkipRoute(this.job_id);
this.getJobPlaintiffs(this.job_id);
};

getJobPlaintiffs(job_id) {
  this._demoService.getJobPlaintiffs(job_id).subscribe(
     data => { this.job_plaintiffs = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 deleteJobPlaintiff(job_plaintiff_id) {
  if (confirm('Are you sure you want to delete this Plaintiff? ')) {
    this._demoService.deleteJobPlaintiff(job_plaintiff_id).subscribe(
       data => {
     // reset the plaintiff list.
     this.getJobPlaintiffs(this.job_id);
     this.toastr.warning('Plaintiff removed from job.');
         return true;
       },
       error => {
         console.error('Error deleting !');
        return console.log(error);
       }
    );
}
}

private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => this.job_status = res,
      err => console.error(err.status)
    );
}


  
    // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
    getHtml(html){
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
      // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
    // WORKS as I created my own function from this articel == pretty well convers
    transform2(value: any, args?: any): any {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.documentElement.textContent;
    }
  
  
    copyToClipboard(id) {
      const content = document.getElementById(id).innerHTML; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }
    
    copyToClipboardPlainText(id) {
      const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      this.clipboard.copy(content);
      this,this.toastr.info(" Copied")
      // this.copyInGrid('btnTwo', id);
    }


    importPrevContentToHTML(id, content_sent, model) {
      if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
      // model.id = id+'_HTML'
      // const content = document.getElementById(id).innerText; // copy all formatting.
      // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
      // this.clipboard.copy(this.removeTags(content));
      // this.clipboard.copy(content);

      const content = content_sent; // copy all formatting.
      // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
      

      // this.attemptForm.controls['general_notes_HTML'].setValue(content);
      this.jobForm.controls[id+'_HTML'].setValue(content);
      this.model.special_instructions_HTML = content;


      this.toastr.info("Updated Version: " + id+'_HTML')
      // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
      // this.copyInGrid('btnTwo', id);
      }
    }
    
    // shows pre version field by id // ngif statments hard coded on each old text box
    showPrevVersion(id) {
      this.showPrevVersion_Field = id;
    
    } 

    hidePrevVersion() {
      this.showPrevVersion_Field = '';
    
    } 



getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }




  }
  
    // Allows formatting of dates etc...
    export class DatePipeComponent {
      today: number = Date.now();
      fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
    // tslint:disable-next-line:eofline
    }
  
